export const pdfCVUrl = "../assets/CV_TomasOles.pdf";
export const pdfCVFilename= "CV_TomasOles.pdf";
// Static CV page lives in /public/cv and is copied verbatim into the build.
export const cvPageUrl = `${process.env.PUBLIC_URL}/cv/`;
export const githubLink = "https://github.com/tomasoles";
export const linkedInProfile = "https://www.linkedin.com/in/tom%C3%A1%C5%A1-ole%C5%A1-ba1759210/";
export const scholarProfile = "https://scholar.google.com/citations?user=KwhWW0QAAAAJ&hl=sk&oi=ao";
